import React, { useEffect, useRef } from 'react';
import { Star } from 'lucide-react';

interface TextSelectionPopoverProps {
  position: { x: number; y: number };
  onMark: () => void;
  onDismiss: () => void;
}

export const TextSelectionPopover: React.FC<TextSelectionPopoverProps> = ({
  position,
  onMark,
  onDismiss,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onDismiss();
      }
    };
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onDismiss();
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onDismiss]);

  return (
    <div
      ref={ref}
      className="fixed z-50 animate-in fade-in slide-in-from-bottom-1 duration-150"
      style={{ left: position.x, top: position.y }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          onMark();
        }}
        className="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-medical-800 border border-medical-200 dark:border-medical-700 rounded-lg shadow-lg text-sm font-medium text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors"
      >
        <Star className="h-3.5 w-3.5" />
        Mark as Key Finding
      </button>
    </div>
  );
};
